import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {BranchPricingSchemeHdrLinkContainerModel} from '../../../../../../models';

@Injectable({providedIn: 'root'})
export class BranchPricingSchemeHdrLinkService extends BaseApiTemplateService<BranchPricingSchemeHdrLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-pricing-scheme-hdr-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'branch-pricing-scheme-hdr-links/backoffice-ep';
    this.httpClient = http;
  }

}
